<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../lib/Common/Http/HttpRequestUtil";
    import HttpRequestOption from "../../lib/Common/Http/HttpRequestOption";
    import {HttpRequestType} from "../../lib/Common/Http/HttpRequestType";

    export let space;

    onMount(() => {
        tracking(true);
        setInterval(() => {
            tracking(false);
        }, 60 * 1000);
    });

    function tracking(isActive: boolean) {
        const paramMap = {};
        const spaceId = space.id;
        paramMap['space_id'] = spaceId;

        if (isActive) {
            paramMap['active'] = undefined;
        }

        const url = UrlUtil.createApiUrl("space_user_access_log/beat", paramMap);

        const option = HttpRequestOption.createForPost();
        option.displayMessageType = HttpRequestType.DisplayMessageType.None;
        HttpRequestUtil.postRequest(url, paramMap, (response) => {


        }, option);
    }


</script>

<!--<div class="space-user-tracking-view">-->


<!--</div>-->
<style lang="scss">
    .space-user-tracking-view {

    }
</style>